module.exports = __webpack_public_path__ + "img/15-2.3d4c6337.png";